"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireWildcard(require("react"));

var _classnames2 = _interopRequireDefault(require("classnames"));

var _container = _interopRequireDefault(require("../container"));

var _icon = _interopRequireDefault(require("../icon"));

var _indexModule = _interopRequireDefault(require("./index.module.scss"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var ESCAPE_KEYCODE = 27;
var TAB_KEYCODE = 9;
var FOCUSABLE_ELEMENTS = 'a[href], button, textarea, input, select';

var Modal = function Modal(_ref) {
  var className = _ref.className,
      classNames = _ref.classNames,
      onDismiss = _ref.onDismissButtonClick,
      children = _ref.children,
      _ref$containerSize = _ref.containerSize,
      containerSize = _ref$containerSize === void 0 ? 'medium' : _ref$containerSize,
      internalDismiss = _ref.internalDismiss,
      isOpen = _ref.isOpen,
      shouldCloseOnOverlayClick = _ref.shouldCloseOnOverlayClick,
      a11y = _ref.a11y;
  var overlayRef = (0, _react.useRef)(null);
  var modalRef = (0, _react.useRef)(null);
  var dismissRef = (0, _react.useRef)(null);

  var handleTabKey = function handleTabKey(e) {
    if (!modalRef.current || !dismissRef.current) {
      return;
    }

    var focusables = modalRef.current.querySelectorAll(FOCUSABLE_ELEMENTS);
    var lastFocusable = focusables[focusables.length - 1];

    if (!e.shiftKey && document.activeElement === lastFocusable) {
      dismissRef.current.focus();
      e.preventDefault();
    } else if (e.shiftKey && document.activeElement === dismissRef.current) {
      lastFocusable.focus();
      e.preventDefault();
    }
  };

  var handleKeyDown = (0, _react.useCallback)(function (e) {
    if (e.keyCode === ESCAPE_KEYCODE) {
      // Escape cancels the modal.
      onDismiss();
    }

    if (e.keyCode === TAB_KEYCODE) {
      // Trap  focus in the modal
      handleTabKey(e);
    }
  }, [onDismiss]);
  var handleOverlayClick = (0, _react.useCallback)(function (e) {
    if (shouldCloseOnOverlayClick && e.target === overlayRef.current) {
      // Overlay click cancels the modal.
      onDismiss();
    }
  }, [onDismiss, shouldCloseOnOverlayClick]);
  (0, _react.useEffect)(function () {
    if (isOpen && modalRef.current && dismissRef.current) {
      var focusables = modalRef.current.querySelectorAll(FOCUSABLE_ELEMENTS); //Note: focuseables[0] === dismissRef

      var firstFocusable = focusables[1];

      if (firstFocusable) {
        firstFocusable.focus();
      } else {
        dismissRef.current.focus();
      }
    }
  }, [isOpen]);
  (0, _react.useEffect)(function () {
    document.addEventListener('keydown', handleKeyDown);
    return function () {
      return document.removeEventListener('keydown', handleKeyDown);
    };
  }, [handleKeyDown]);
  return /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames2.default)(_indexModule.default.Modal, (0, _defineProperty2.default)({}, _indexModule.default.modalOpen, isOpen), className, classNames === null || classNames === void 0 ? void 0 : classNames.overlay),
    ref: overlayRef,
    onClick: handleOverlayClick
  }, /*#__PURE__*/_react.default.createElement(_container.default, {
    type: containerSize,
    className: (0, _classnames2.default)(_indexModule.default.modalContents, classNames === null || classNames === void 0 ? void 0 : classNames.content)
  }, /*#__PURE__*/_react.default.createElement("div", {
    role: "dialog",
    "aria-label": a11y === null || a11y === void 0 ? void 0 : a11y.label,
    "aria-labelledby": a11y === null || a11y === void 0 ? void 0 : a11y.labelledby,
    "aria-describedby": a11y === null || a11y === void 0 ? void 0 : a11y.describedby,
    "aria-modal": true,
    ref: modalRef
  }, /*#__PURE__*/_react.default.createElement("button", {
    className: (0, _classnames2.default)(internalDismiss ? _indexModule.default.internalDismiss : _indexModule.default.externalDismiss, classNames === null || classNames === void 0 ? void 0 : classNames.icon),
    type: "button",
    "aria-label": "Dismiss modal",
    onClick: onDismiss,
    ref: dismissRef
  }, /*#__PURE__*/_react.default.createElement(_icon.default, {
    type: "cross",
    className: _indexModule.default.icon,
    size: "small"
  })), children)));
};

Modal.propTypes = {
  isOpen: _propTypes.default.bool.isRequired,
  containerSize: _propTypes.default.oneOf(['small', 'medium', 'large']),
  internalDismiss: _propTypes.default.bool,
  className: _propTypes.default.string,
  classNames: _propTypes.default.shape({
    overlay: _propTypes.default.string,
    content: _propTypes.default.string,
    icon: _propTypes.default.string
  }),
  shouldCloseOnOverlayClick: _propTypes.default.bool,
  a11y: _propTypes.default.shape({
    label: _propTypes.default.string,
    labelledby: _propTypes.default.string,
    describedby: _propTypes.default.string
  })
};
var _default = Modal;
exports.default = _default;